@if (data.notice_type === 'login') {
  <section>
    <div class="message">Please login to access this feature</div>
  </section>
}
@if (data.notice_type === 'recaptcha') {
  <section>
    <div class="message">Please complete the reCAPTCHA verification</div>
  </section>
}